module.exports = __webpack_public_path__ + "static/DSC_9450-f4d35a44ad1b5ccf73aece484389b7f4.jpg";